orders-planner-line-ui-schedules-uneditable
  orders-planner-line-ui-schedules-cell-uneditable(each="{id in opts.schedules}" tag-scope="{dataScopeSchedule(id)}")
  script(type="typescript").
    this.mixin('orders.planner.line-ui.schedules');
